import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LiveChat = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    if (isHomePage) {
      return;
    }

    if (window.LiveChatWidget) {
      return;
    }

    window.__lc = window.__lc || {};
    window.__lc.license = 19228651;
    window.__lc.integration_name = "manual_onboarding";
    window.__lc.product_name = "livechat";

    const script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.src = 'https://cdn.livechatinc.com/tracking.js';

    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[src="https://cdn.livechatinc.com/tracking.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [isHomePage]);

  if (isHomePage) {
    return null;
  }

  return (
    <noscript>
      <a href="https://www.livechat.com/chat-with/19228651/" rel="nofollow">
        Chat with us
      </a>
      , powered by{' '}
      <a 
        href="https://www.livechat.com/?welcome" 
        rel="noopener noreferrer" 
        target="_blank"
      >
        LiveChat
      </a>
    </noscript>
  );
};

export default LiveChat;
